import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown } from 'antd'
import { CaretDownOutlined, CaretUpOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useMsal } from '@azure/msal-react'

import styles from './styles.module.less'

interface Props {
    logout: () => void
}

export default function UserMenu({ logout }: Props): JSX.Element {
    const [dropdownVisible, setDropdownVisible] = useState<boolean>(false)
    const { t } = useTranslation('APP')
    const { instance } = useMsal()

    function logoutHandler() {
        const [account] = instance.getAllAccounts()
        const logoutRequest = {
            account,
            postLogoutRedirectUri: '/redirect',
        }
        instance.logoutRedirect(logoutRequest)
        logout()
    }

    return (
        <Dropdown
            onVisibleChange={() => setDropdownVisible(!dropdownVisible)}
            overlay={
                <ul className={styles.user_menu}>
                    <li className={styles.user_menuItem}>
                        <Link onClick={() => setDropdownVisible(false)} to="/user">
                            <SettingOutlined />
                            <span>{t('components.header.profileMenu.settings')}</span>
                        </Link>
                    </li>
                    <li className={styles.user_menuItem}>
                        <button onClick={() => logoutHandler()} type="button">
                            <LogoutOutlined />
                            <span>{t('components.header.profileMenu.logout')}</span>
                        </button>
                    </li>
                </ul>
            }
            placement="bottomRight"
            trigger={['click']}
            visible={dropdownVisible}
        >
            <button className={styles.headerBtn} type="button">
                <UserOutlined className={styles.headerBtn_avatar} />
                {/* <span className={styles.headerBtn_label}>{label || t('header.profileMenu.label')}</span> */}
                {dropdownVisible ? (
                    <CaretUpOutlined className={styles.headerBtn_caret} />
                ) : (
                    <CaretDownOutlined className={styles.headerBtn_caret} />
                )}
            </button>
        </Dropdown>
    )
}
